import PropTypes from 'prop-types'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'
import VoucherService from 'domains/voucher/services/voucher-service'
import { DISCOUNT_FOR } from 'domains/voucher/constants/voucher-constants'
import PriceUtil from 'utils/price-util'


const propTypes = {
  voucher: PropTypes.shape({
    id   : PropTypes.number.isRequired,
    code : PropTypes.string.isRequired,
    rule : PropTypes.object.isRequired
  })
}

const VoucherShipmentDiscountView = ({ voucher }) => {
  const isAbsolute   = VoucherService.isDiscountAbsolute(voucher, DISCOUNT_FOR.SHIPMENT)
  const isPercentage = VoucherService.isDiscountPercentage(voucher, DISCOUNT_FOR.SHIPMENT)

  return (
    <tr>
      <td>
        <img src={ `${WEB_URL_CONSTANTS.HOMEPAGE}/icons/voucher.svg` } />
        { ' Shipping Discount' }
      </td>

      {
        isAbsolute &&
          <td className='font-weight-bold'>
            { PriceUtil.formatToIDR(voucher.rule.shipment_discount_absolute) }
          </td>
      }

      {
        isPercentage &&
        <td>
          <span className='font-weight-bold'>
            { `${voucher.rule.shipment_discount_percentage}%` }
          </span>
          <span className='ml-1'>
            { `(maks. ${PriceUtil.formatToIDR(voucher.rule.shipment_discount_percentage_max)})` }
          </span>
        </td>
      }
    </tr>
  )}

VoucherShipmentDiscountView.propTypes = propTypes

export default VoucherShipmentDiscountView